import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchHighlights(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/highlights', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteHighlights(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/highlights/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
